import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import ChecksComponent from '@/modules/common/common/components/insuranceAccordions/ChecksComponent.vue'

export default class AccordionChecks extends AbstractAccordion<{ text: string; check: boolean }> {
  component = shallowRef(ChecksComponent)

  constructor(attributes: Partial<AccordionChecks>) {
    super(attributes)
  }
}
